import { render, staticRenderFns } from "./forms-table.vue?vue&type=template&id=188f55b0"
import script from "./forms-table.vue?vue&type=script&lang=js"
export * from "./forms-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports